// extracted by mini-css-extract-plugin
module.exports = {"eu_eco_nav_new":"EUEcoAnchorNew_eu_eco_nav_new__8wWDZ"};